/**
 * Responsive helpers
 *
 * @desc Utility functions to make the app work better responsively.
 */
class ResponsiveHelpers {

    /**
     * Set the login view styles
     */
    static setLoginView () {
        if(undefined !== window && "document" in window) {
            window.document.body.removeAttribute("page-dashboard");
            window.document.body.setAttribute("user-login", true);
            window.document.getElementById("content-region").style.cssText = "margin-top: 0;";
        }
    }

    /**
     * Unset the login view styles
     */
    static unsetLoginView () {
        if(undefined !== window && "document" in window) {
            window.document.body.removeAttribute("user-login");
            window.document.getElementById("content-region").removeAttribute("style");
        }
    }

    static headerbarResize () {
        const el = $("#content-region")[0];

        if (undefined === el.getAttribute("style") && window.innerWidth > 992) {
            return;
        }

        if (window.innerWidth < 992 && window.innerWidth >= 376) {
            el.style.cssText = "margin-top: 200px";
        }

        if (window.innerWidth <= 355) {
            el.style.cssText = "margin-top: 270px";
        }

        if (window.innerWidth > 992) {
            el.removeAttribute("style");
        }
    }

}

export default ResponsiveHelpers;


// WEBPACK FOOTER //
// ./public/domain/controllers/responsive-helpers/index.js